
<template>
  <div class="footer">
    <!-- TODO: refactor markup -->

    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h4 v-translate>About us</h4>
          <ul>
            <li>SAVANA Tourist Enterprises 2017</li>
          </ul>
        </div>
        <div class="col-md-6">
          <h4 v-translate>Contact</h4>
          <ul >
            <li><b-icon icon="house-door"  class="mr-2"/>ул. Орце Николов бр.24 1000 Скопје , Македонија</li>
            <li><b-icon icon="envelope" class="mr-2"/><a href="mailto:booking@savana.com.mk">booking@savana.com.mk</a></li>
            <li><b-icon icon="phone"  class="mr-2"/>+389 2 3115 826</li>
            <li><b-icon icon="at"  class="mr-2"/>&nbsp;<a href="#" target="_blank">Facebook</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
